import React from 'react';
import styled from 'styled-components/native';
import { H4 } from '../../components/Typography';
import HeaderTabView from '../../components/HeaderTabView';
import Spacer from '../../components/Spacer';
import { Platform } from 'react-native';
import { log } from '../../tools/LogHelper';

const StyledContainer = styled.View`
  flex: 1;
  background-color: white;
  padding: ${Platform.OS === 'web' ? 100 : 20}px 20px 20px 20px;
`;
const ExampleHeaderTabViewScreen: React.FC = () => {
  return (
    <StyledContainer>
      <H4>Header Tab View</H4>
      <Spacer size={2} />
      <HeaderTabView
        tabs={['Earn', 'Redeem']}
        onTabChange={tab => {
          log('Selected Tab:', tab);
        }}
      />
      <Spacer />
      <HeaderTabView
        tabs={['Active', 'Past', 'Favorites']}
        onTabChange={tab => {
          log('Selected Tab:', tab);
        }}
      />
      <Spacer />
      <HeaderTabView
        tabs={['One', 'Two', 'Three', 'Four']}
        onTabChange={tab => {
          log('Selected Tab:', tab);
        }}
      />
    </StyledContainer>
  );
};
export default ExampleHeaderTabViewScreen;
